import PaginationComponent from 'components/pagination/pagination-component'
import { useSelector } from 'react-redux'
import { selectWhitelist } from 'store/whitelist/selectors'

export default function WhitelistPagination({
  onChange,
}: {
  onChange: (i: number) => void
}) {
  const { currentPage, pageSize, totalItem } = useSelector(selectWhitelist)

  return (
    <div className='wa__pagination'>
      <PaginationComponent
        total={totalItem}
        current={currentPage}
        pageSize={pageSize}
        onChange={(index) => onChange(index)}
      />
    </div>
  )
}
